import { _integratedAxios } from '@/plugins/axios/integratedAxios';

/**
 *
 * @description : 로그인 정보
 * @returns : Promise
 */
const loginApi = params => {
  return _integratedAxios.post(`/admin/auth/login?email=${params.email}&idx=${params.idx}`, {});
};

/**
 *
 * @description : 토큰 정보
 * @returns : Promise
 */
const tokenAPi = params => {
  return _integratedAxios.post('/admin/auth/token', {
    token: params.token,
  });
};

/**
 *
 * @description : HQ매니저 정보
 * @returns : Promise
 */
const hqMamagerApi = (teamIdx = 0) => {
  return _integratedAxios.get(`/admin/common/staff/list/${teamIdx}`, {});
};

/**
 *
 * @description : 수강신청 리스트 api
 * @returns : Promise
 */
const sugangListApi = params => {
  return _integratedAxios.get(`/admin/sugang/list`, {
    params: {
      companyIdx: params.companyIdx,
      startDate: params.startDate,
      endDate: params.endDate,
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      platformName: params.platformName,
      teamIdx: params.teamIdx,
      hqIdx: params.hqIdx,
    },
  });
};

/**
 *
 * @description : 회사 리스트 api
 * @returns : Promise
 */
const companyListApi = name => {
  return _integratedAxios.get(`/admin/common/company/list`, {
    params: {
      name: name,
    },
  });
};

/**
 *  @description : 수강 신청 폐쇠 비활성/활성 수정
 *  @returns : Promise
 */
const closeSugangApi = params => {
  return _integratedAxios.put(`/admin/sugang/close/${params.sugangIdx}?isClose=${params.isClose}`, {});
};

/**
 * @description : 수강신청 코드 체크
 * @returns : Promise
 */
const codeCheckApi = code => {
  return _integratedAxios.get(`/admin/sugang/code-check/${code}`, {});
};

/**
 * @description : 파일 업로드
 * @returns : Promise
 */
const fileUploadApi = frm => {
  return _integratedAxios.post('/upload', frm, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * @description : faq 리스트
 * @returns : Promise
 */
const faqListApi = () => {
  return _integratedAxios.get('/admin/common/faq-category/list');
};

/**
 *  @description : 템플릿 리스트
 * @returns : Promise
 */
const templateListApi = () => {
  return _integratedAxios.get(`/admin/common/template/list`);
};

/**
 *  @description : 수강 등록 insert
 * @returns : Promise
 */
const sugangRegisterApi = data => {
  return _integratedAxios.post('/admin/sugang', data);
};

/**
 * @description : 수강 정보 상세 조회
 * @returns : Promise
 */
const sugangDetailApi = sugangIdx => {
  return _integratedAxios.get(`/admin/sugang/${sugangIdx}`);
};

/**
 * @description : 수강 정보 수정
 * @returns : Promise
 */
const sugangModifyApi = (sugangIdx, data) => {
  return _integratedAxios.put(`/admin/sugang/${sugangIdx}`, data);
};

/**
 * @description : 수강 공지사항 조회
 * @returns : Promise
 */
const sugangNoticeListApi = params => {
  return _integratedAxios.get(`/sugang/${params.sugangIdx}/board/notice/list`, {
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
    },
  });
};

/**
 * @description : 수강 공지사항 추가
 * @returns : Promise
 */
const sugangAddNoticeApi = (sugangIdx, data) => {
  return _integratedAxios.post(`/sugang/${sugangIdx}/board/notice`, data);
};

/**
 * @description : 수강 공지사항 Detail 조회
 * @returns : Promise
 */
const sugangNoticeDetailApi = (sugangIdx, boardIdx) => {
  return _integratedAxios.get(`/sugang/${sugangIdx}/board/notice/${boardIdx}`);
};

const sugangNoticeDeleteApi = (sugangIdx, data) => {
  return _integratedAxios.delete(`/sugang/${sugangIdx}/board/notice/list`, {
    data: data,
  });
};
/**
 * @description : 수강 공지사항 수정
 * @returns : Promise
 */
const sugangNoticeModifyApi = (sugangIdx, boardIdx, data) => {
  return _integratedAxios.put(`/sugang/${sugangIdx}/board/notice/${boardIdx}`, data);
};

/**
 * @description : FAQ 리스트 api
 * @returns : Promise
 */
const sugangGetFaqListApi = faqCategoryIdx => {
  return _integratedAxios.get(`/sugang/faq/${faqCategoryIdx}/list`, {
    params: {
      pageSize: -1,
      pageNum: -1,
    },
  });
};

/**
 * @description : FAQ 리스트 순서변경
 * @returns : Promise
 */
const sugangChangeSortApi = (faqCategoryIdx, data) => {
  return _integratedAxios.put(`/sugang/faq/${faqCategoryIdx}/sort`, data);
};

/**
 * @description : FAQ 선택 삭제 api
 * @returns : Promise
 */
const sugangFaqDeleteApi = (faqCategoryIdx, data) => {
  return _integratedAxios.delete(`/sugang/faq/${faqCategoryIdx}/list`, {
    data: data,
  });
};

/**
 * @description : FAQ 추가 api
 * @returns : Promise
 */
const sugangFaqAddApi = data => {
  return _integratedAxios.post(`/sugang/faq`, data);
};

/**
 * @description : FAQ Detail api
 * @returns : Promise
 */
const sugangFaqDetailApi = faqIdx => {
  return _integratedAxios.get(`/sugang/faq/${faqIdx}`);
};

/**
 * @description : FAQ Modify api
 * @returns : Promise
 */
const sugangFaqModifyApi = (faqIdx, data) => {
  return _integratedAxios.put(`/sugang/faq/${faqIdx}`, data);
};
/**
 * @description : ITM 언어리스트 api
 * @returns : Promise
 */
const sugangGetLanguageListApi = () => {
  return _integratedAxios.get(`/admin/itm/tutor/language/list`);
};
/**
 * @description : ITM 강사리스트 api
 * @returns : Promise
 */
const sugangGetTutorListApi = index => {
  return _integratedAxios.get(`/admin/itm/tutor/list`, {
    params: {
      languageIdx: index,
    },
  });
};
const sugangTutorAddApi = data => {
  return _integratedAxios.post(`/admin/itm/tutor`, data);
};
const sugangTutorModifyApi = (data, tutorIdx) => {
  return _integratedAxios.put(`/admin/itm/tutor/${tutorIdx}`, data);
};
const sugangTutorChangeSortApi = (tutorIdx, data) => {
  return _integratedAxios.put(`/admin/itm/tutor/${tutorIdx}/sort`, data);
};
const sugangTutorDeleteApi = (tutorCategoryIdx, data) => {
  return _integratedAxios.delete(`/admin/itm/tutor/${tutorCategoryIdx}`, {
    data: data,
  });
};
const sugangTutorDataApi = tutorIdx => {
  return _integratedAxios.get(`/admin/itm/tutor/${tutorIdx}`);
};
const sugangTutorReviewApi = tutorIdx => {
  return _integratedAxios.get(`/admin/itm/tutor/${tutorIdx}/review?pageNum=1&pageSize=50`);
};
const sugangTutorReviewAddApi = (tutorIdx, data) => {
  return _integratedAxios.post(`/admin/itm/tutor/${tutorIdx}/review`, data);
};
const sugangTutorReviewDeleteApi = (tutorIdx, data) => {
  console.log(data);
  return _integratedAxios.delete(`/admin/itm/tutor/${tutorIdx}/review`, {
    data: data,
  });
};
export {
  loginApi,
  tokenAPi,
  hqMamagerApi,
  sugangListApi,
  companyListApi,
  closeSugangApi,
  codeCheckApi,
  fileUploadApi,
  faqListApi,
  templateListApi,
  sugangRegisterApi,
  sugangDetailApi,
  sugangModifyApi,
  sugangNoticeListApi,
  sugangAddNoticeApi,
  sugangNoticeDetailApi,
  sugangNoticeDeleteApi,
  sugangNoticeModifyApi,
  sugangGetFaqListApi,
  sugangChangeSortApi,
  sugangFaqDeleteApi,
  sugangFaqAddApi,
  sugangFaqDetailApi,
  sugangFaqModifyApi,
  sugangGetLanguageListApi,
  sugangGetTutorListApi,
  sugangTutorAddApi,
  sugangTutorModifyApi,
  sugangTutorChangeSortApi,
  sugangTutorDeleteApi,
  sugangTutorDataApi,
  sugangTutorReviewApi,
  sugangTutorReviewAddApi,
  sugangTutorReviewDeleteApi,
};
